<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row(v-show="!loading")
      v-col.py-0
        v-card.elevation-6.mb-5(style="overflow: hidden")
          app-full-entity(
            :ignoreTabs="ignorableTabs",
            v-bind="{ customLabel, tabsWithErrors, entity }"
          )
              template(v-slot:packageContents="props")
                  package-contents(v-bind="{...props, reverseMap: !!instance.uid}")

    v-row.pl-5(v-if="entity", v-show="!loading", align="center")
      v-col.py-0(cols="12")
        g-btn.mr-3.white--text.float-right(color="geoGreen", @click="save", width="131", :disabled="isBlockEdit") {{ $t('Common.save') }}
        g-btn.mr-3.float-right(color="error", outlined, @click="redirectToIndex", width="100") {{ $t('Common.cancel') }}
  </template>

<style lang="scss" scoped>
.error {
  background-color: red !important;
}

.v-card {
  min-height: 350px;
}
</style>

<script>
import axios from "axios";
import _ from "lodash";
import EntityMixin from "@/mixins";

export default {
  mixins: [EntityMixin],
  name: "package-add",
  data: function () {
    return {
      activeTab: 0,
      errors: {},
      tabsWithErrors: [],
      disregardErrorInTabs: [],
      loading: true,
      permIgnore: [],
      loads: ["ExtraData", "Shipment", "Status", "PackageContents.Product", "PackageContents.OrderLine", "PackageContents.ShipmentItem"],
    };
  },
  computed: {
    isBlockEdit() {
      return this.instance.status && this.instance.status.blockEdit
    },
    customLabel() {
      return ({
        Package: this.$t('Common.general'),
      });
    },
    entityName() {
      return "Package";
    },
    entity() {
      return this.$findEntity("Package");
    },
    uid() {
      return this.$route.params.item;
    },
    shipmentItemEntity() {
      return this.$findEntity("ShipmentItem");
    },
    shipmentItemPath() {
      return "shipmentItems"
    },
    shipmentItemRelation() {
      let fakeRelation = this.shipmentItemEntity;
      fakeRelation.multiple = true;
      return fakeRelation;
    },
    ignorableTabs() {
      return this.permIgnore;
    },
  },
  methods: {
    errorInTab({ name }) {
      return this.tabsWithErrors.some((e) => e == name);
    },
    disregardErrorInTab(tabindex) {
      return this.disregardErrorInTabs.some((e) => e == tabindex);
    },
    formatedErrors(relation) {
      if (this.disableErrorTabs) return [];
      return Object.keys(
        this.$formatErrors(this.$store.state.errors, relation)
      );
    },
    findTabErrors(errors, relation) {
      console.log("evaluating errors", this.$cleanString(errors), this.$cleanString(relation));
      // TODO
      // find fields in relation that has the name of the error
      // return those errors that matches fields in the relation
      return errors;
    },
    getLabel(val) {
      var labelAttribute = val.tabLabel || val.name;
      if (!labelAttribute) return "";
      labelAttribute = labelAttribute.replace(/\_[\d]+/, "");
      let customLabelObject = this.customLabel;
      //If the customLabel prop is empty and the entity has customLabel property on the projectConfig, use them
      if (_.isEmpty(customLabelObject) && this.$getCustomLabel(this.entity.name)) {
        customLabelObject = this.$getCustomLabel(this.entity.name);
      }
      return this.$displayName(_.get(customLabelObject, labelAttribute, labelAttribute));
    },
    getEntityRelation(relation) {
      const { type, extra } = relation;
      if (this.portal && extra) return relation;
      return this.$findEntity(type);
    },
    /**
     * Go back to the packages index
     */
    redirectToIndex() {
      this.$router.push({
        name: "package.index",
      });
    },
    /**
    Get Business Scope according to the businessScopeId given
    */
    async getBusinessScope(businessScopeId) {
      if (businessScopeId == null) return null;
      let bs = (await axios.get("BusinessScope?where[]=id=" + businessScopeId)).data.data;
      return bs[0];
    },

    /**
    Map the errors on the entity fields
    TODO: fix all the routes of possible errors.
    */
    mapErrors(errors = {}) {
      this.tabsWithErrors = [];
      const rootFields = [];
      if (_.keys(errors).some((r) => _.some(rootFields, (v) => r.includes(v))))
        this.tabsWithErrors.push("Package");
    },
    /**
     * Save the Package into database.
     * **/
    async save() {
      try {
        this.loading = true;
        //Set the business scope if user didn't select any.
        if (this.instance.businessScope == null || this.instance.businessScopeId === null)
          this.instance.businessScopeId = this.$getBusinessScopeId();

        let _clonedInstance = _.cloneDeep(this.instance);

        if (_clonedInstance.packageContents) {
          _clonedInstance.packageContents.forEach(content => {
            content.package = null;
          });
        }


        //Send the http post request
        this.instance = (await axios.post('entity/graph', _clonedInstance)).data

        //If success, return to index
        this.redirectToIndex();
      }
      catch (error) {
        const requestErrors = _.get(error, "response.data.errors");
        if (requestErrors) {
          this.errors = error.response.data.errors;
          this.mapErrors(requestErrors);
        }
        console.log(`[Package][save] error: `, this.$cleanString(error));
      }
      finally {
        this.loading = false;
      }
    },
    async load() {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, ...this.loads);
          let _instance = (await axios.get(endpoint, { _Entity: this.entity.name, uid: this.uid })).data;

          this.instance = _instance;
          this.instance.entityState = 3;

          //verify if the package has an uID
          if (!_.get(this.instance, 'packageNo')) {
            this.instance.packageNo = this.$generateUid();
          }

          //Cleanup from deleted package contents
          this.instance.packageContents = _instance.packageContents.filter(pc => pc.deletedAt == null && pc.entityState != 2);

          const { status } = this.instance;
          ({ blockEdit: this.blockEdit } = status || {});
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      } else {
        const lsbusinessScopeId = window.localStorage.getItem("BusinessScopeId");
        const lsbusinessScope = await this.getBusinessScope(lsbusinessScopeId);
        this.$store.commit("SET_INSTANCE", {
          entityState: 4,
          _Entity: this.entity.name,
          user: this.$store.state.user.user,
          businessScopeId: lsbusinessScopeId,
          businessScope: lsbusinessScope,
          packageContents: [],
          shipmentItems: [],
          packageNo: this.$generateUid(),
          packaging: '',
          caseIdentifier: '',
        });
        this.loading = false;
      }
    },
  },
  async created() {
    await this.load();
  },
};
</script>
